// Static site data for Clickory
export const LINKS = {
  bookProject: "https://tally.so/r/b5EyVe",
  instagram: "https://www.instagram.com/clickoryhq?igsh=Nm90c2V3YWp0ZnA5&utm_source=qr",
  facebook: "https://www.facebook.com/share/1JKR1n2NP2/",
  linkedin: "https://www.linkedin.com/company/clickoryhq/about/?viewAsMember=true",
  twitter: "https://x.com/clickoryhq",
  email: "hello.clickory@gmail.com",
  whatsapp: "https://wa.me/message/clickory",
};

export const CREATORS = [
  { name: "Max the Meat Guy",   subs: "9.60M+ Subscribers", img: "/assets/creators/Max%20the%20Meat%20Guy.jpg" },
  { name: "Khalid Al Ameri",    subs: "6.25M+ Subscribers", img: "/assets/creators/Khalid%20Al%20Ameri.jpg" },
  { name: "DSARM",              subs: "525K+ Subscribers",  img: "/assets/creators/%20DSARM.jpg" },
  { name: "Thogden",            subs: "2.60M+ Subscribers", img: "/assets/creators/%20Thogden.jpg" },
  { name: "Cole Anderson-James",subs: "820K+ Subscribers",  img: "/assets/creators/Cole%20Anderson-James.jpg" },
  { name: "Harry Jaggard",      subs: "2.80M+ Subscribers", img: "/assets/creators/Harry%20Jaggard.jpg" },
  { name: "Matt Shoe",          subs: "615K+ Subscribers",  img: "/assets/creators/Matt%20Shoe.jpg" },
  { name: "POVINME",            subs: "2.95M+ Subscribers", img: "/assets/creators/POVINME.jpg" },
  { name: "vanzai",             subs: "11.2M+ Subscribers", img: "/assets/creators/%20vanzai.jpg" },
  { name: "Chef Tyler",         subs: "5.70M+ Subscribers", img: "/assets/creators/Chef%20Tyler.jpg" },
  { name: "Kash World",         subs: "590K+ Subscribers",  img: "/assets/creators/Kash%20World.jpg" },
  { name: "MattDoesFitness",    subs: "2.40M+ Subscribers", img: "/assets/creators/%20MattDoesFitness.jpg" },
  { name: "Zenith FRS",         subs: "190K+ Subscribers",  img: "/assets/creators/zenith.jpg" },
  { name: "Resfeezy",           subs: "1.33M+ Subscribers", img: "/assets/creators/resfeezy.jpg" },
  { name: "NoHandMTB",          subs: "287K+ Subscribers",  img: "/assets/creators/nohand.jpg" },
];

export const STATS = [
  { icon: "Eye",  value: 547, suffix: "M+", label: "Views Across Client Videos" },
  { icon: "Image",value: 1500, suffix: "+",  label: "Thumbnails Designed" },
  { icon: "User", value: 120, suffix: "+",  label: "Creators Worked With" },
];

// Featured project thumbnails, arranged into 5 rows for the marquee.
// Each row is duplicated multiple times in the render to create a seamless
// infinite loop with no visible gaps at any viewport size.
// Rows 1-3: 23 unique thumbnails (no repeats). Rows 4-5 reuse the same pool in a different order. Same list on desktop & mobile.
export const FEATURED_ROWS = [
  {
    id: "row-1",
    duration: 54,
    reverse: false,
    items: [
      "/assets/featured/new-caj-10.jpg",
      "/assets/featured/new-cg-marathon.jpg",
      "/assets/featured/MTMG%203%20-%20I%20Injected%20Ribeyes%201.jpg",
      "/assets/featured/new-rf-netflix.jpg",
      "/assets/featured/CAJ_3_F.jpg",
      "/assets/featured/1.jpg",
      "/assets/featured/new-nhm-emoto.jpg",
      "/assets/featured/MTMG%202%20v2.jpg",
    ],
  },
  {
    id: "row-2",
    duration: 58,
    reverse: true,
    items: [
      "/assets/featured/new-caj-5.jpg",
      "/assets/featured/DSARM%202%20MC.jpg",
      "/assets/featured/POV_4_c1_efoil%20battle_ch_o2.jpg",
      "/assets/featured/PV%202%20o5.jpg",
      "/assets/featured/Vanzai%201%20PC.jpg",
      "/assets/featured/new-caj-2.jpg",
      "/assets/featured/new-zf-motocross.jpg",
      "/assets/featured/CAJ%201%20o1%20wt.jpg",
    ],
  },
  {
    id: "row-3",
    duration: 48,
    reverse: false,
    items: [
      "/assets/featured/POV_15R_3.jpg",
      "/assets/featured/POV_3_Mario%20Party%20in%20Real%20Life_o3.jpg",
      "/assets/featured/new-zf-hayabusa.jpg",
      "/assets/featured/new-ms-designer.jpg",
      "/assets/featured/POV_15R_1_MC_o1.jpg",
      "/assets/featured/MDF%201%20MC.jpg",
      "/assets/featured/CAJ_6_F.jpg",
    ],
  },
  {
    id: "row-4",
    duration: 52,
    reverse: true,
    items: [
      "/assets/featured/new-caj-5.jpg",
      "/assets/featured/PV%202%20o5.jpg",
      "/assets/featured/1.jpg",
      "/assets/featured/Vanzai%201%20PC.jpg",
      "/assets/featured/new-zf-motocross.jpg",
      "/assets/featured/POV_4_c1_efoil%20battle_ch_o2.jpg",
      "/assets/featured/CAJ%201%20o1%20wt.jpg",
      "/assets/featured/new-caj-10.jpg",
    ],
  },
  {
    id: "row-5",
    duration: 50,
    reverse: false,
    items: [
      "/assets/featured/POV_3_Mario%20Party%20in%20Real%20Life_o3.jpg",
      "/assets/featured/Vanzai%201%20PC.jpg",
      "/assets/featured/POV_15R_1_MC_o1.jpg",
      "/assets/featured/new-caj-5.jpg",
      "/assets/featured/PV%202%20o5.jpg",
      "/assets/featured/DSARM%202%20MC.jpg",
      "/assets/featured/new-zf-hayabusa.jpg",
    ],
  },
];

export const FEATURED_ROWS_MOBILE = FEATURED_ROWS;

export const WHY_CARDS = [
  {
    tagLine1: "Strategy",
    tagLine2: "First",
    icon: "Target",
    heading: "Every thumbnail starts with the strongest click angle.",
    body: "We focus on understanding the video’s hook before opening Photoshop.",
  },
  {
    tagLine1: "Concept",
    tagLine2: "Driven",
    icon: "Lightbulb",
    heading: "We don’t just create thumbnails.",
    body: "We develop visual concepts that build curiosity and increase click potential.",
  },
  {
    tagLine1: "Built For",
    tagLine2: "Creators",
    icon: "PenTool",
    heading: "Every project is designed specifically for YouTube creators,",
    body: "balancing performance, storytelling and strong visual communication.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Matt Shoe",
    subs: "555K+ Subscribers",
    img: "/assets/creators/Matt%20Shoe.jpg",
    text: "I've been working with Sohan for over, I think maybe like six months, eight months. He's been a great thumbnail designer. He always understood the assignments. He always put in extra work. He always delivered everything on time and I'm super happy to have him as my thumbnail designer. So, if you want those good thumbnails that get you a lot of views, let Sohan know and he's gonna… he's gonna hook you up.",
  },
  {
    name: "Harry Jaggard",
    subs: "2.71M+ Subscribers",
    img: "/assets/creators/Harry%20Jaggard.jpg",
    text: "Hey guys, Sohan has been helping me out with some thumbnails. He's been doing an incredible job, 10 out of 10. Very professional, very quick. He asks me what I want and he always asks me the deadline and, yeah, he's been making them for a while now on the main channel and also on the second channel. So, doing a great job. Thank you, the legend, and make sure you hire him!",
  },
  {
    name: "Baap Ka Beta",
    subs: "1.4M+ Followers",
    img: "/assets/creators/Baap%20Ka%20Beta.jpg",
    text: "Big shoutout to Sohan. We've been working together for over two years and he's been killing it with my thumbnails. Super easy to work with, always on time, and he actually cares about performance, not just looks. Highly recommend him to any creator who wants more clicks.",
  },
  {
    name: "Waleed Maoed",
    subs: "147K+ Subscribers",
    img: "/assets/creators/Waleed%20Maoed.jpg",
    text: "Yo, I just want to give a big shout out to Sohan. I've been working with him for the past two years and he's been helping me so much optimizing my whole YouTube flow, helping me with my thumbnails. Highly recommend working with him. He is one of the best in the game, if not the best. Check him out.",
  },
];

export const SERVICES = [
  {
    title: ["Design", "Execution"],
    icon: "Settings",
    subtitle: "Perfect for creators who already have a thumbnail concept and need professional execution.",
    bullets: [
      "Client-provided concept",
      "Professional thumbnail design",
      "High-quality Photoshop execution",
      "Up to 4 revision rounds",
      "Final delivery",
    ],
  },
  {
    title: ["Ideation +", "Design"],
    icon: "BrainCircuit",
    subtitle: "Perfect for creators who want us to develop the creative direction before designing.",
    bullets: [
      "Project brief review",
      "Market & competitor analysis",
      "Thumbnail concept development",
      "Concept approval",
      "Final thumbnail design",
      "Up to 4 revision rounds",
    ],
  },
];

export const FULL_PACKAGE = {
  title: ["Full Video", "Packaging"],
  icon: "MonitorPlay",
  subtitle: "A complete packaging solution combining strategic ideation, multiple thumbnail concepts, title suggestions, and final design—all tailored to your video.",
  bullets: [
    { text: "Everything in Ideation + Design", strong: ["Ideation + Design"] },
    { text: "Multiple concept directions with explanation" },
    { text: "Title suggestions aligned with the thumbnail concept" },
    { text: "Video-specific packaging strategy" },
    { text: "Final thumbnail design" },
    { text: "Up to 5 revision rounds" },
  ],
};

export const ADDONS = [
  { title: "A/B Test Variations", body: "Small improvements of the same approved concept." },
  { title: "Alternative Concepts", body: "Completely different thumbnail concepts for the same video." },
  { title: "Additional Revisions", body: "Available when revision rounds are exceeded." },
];

export const FAQS = [
  {
    q: "What do I need to get started?",
    a: "To get started, simply share your **video context** (script, video link, or summary), any available **images**, optional **text**, your **preferences or references** (if any), and your **deadline**. Once we have everything we need, we’ll take care of the creative process from there.",
  },
  {
    q: "Do you only design thumbnails, or do you also create concepts?",
    a: "**Both.** Through our **Ideation + Design** service, we research your video, explore creative directions, and develop thumbnail concepts before moving into the final design. If you already have a concept, we also offer a **Design Execution** service to bring your idea to life with a polished, high-performing design.",
  },
  {
    q: "Can you work if I already have a thumbnail concept?",
    a: "**Absolutely.** Our **Design Execution** service is built specifically for creators who already have a concept. Simply share your sketch, reference, or written direction, and we’ll focus on producing a professional final thumbnail while staying true to your original vision.",
  },
  {
    q: "Do you offer A/B test thumbnails?",
    a: "**Yes.** We offer A/B testing as an **optional add-on**. This includes both **variations of the same approved concept** and **completely different concepts** for the same video, depending on your testing strategy and goals.",
  },
  {
    q: "What’s the typical turnaround time?",
    a: "For **Design Execution**, final thumbnails are typically delivered within **24-48 hours** after the concept has been approved and all required assets have been received.\n\nFor projects that include **Ideation + Design** or our **Full Video Packaging** service, the complete process—from research and concept development to final delivery—typically takes **24-72 hours**.\n\nProject timelines also depend on smooth communication and timely feedback throughout the process.",
  },
  {
    q: "How many revisions are included?",
    a: "Every project includes **up to three rounds of revisions** to refine the approved concept. Additional revisions beyond that may incur a small extra charge. If you’d like to explore a completely new concept or creative direction after approval, it will be treated as a separate project.",
  },
  {
    q: "Do you help with video titles?",
    a: "**Yes.** Title suggestions are included as part of our **Full Video Packaging** service. We develop titles alongside the thumbnail to create stronger overall video packaging and maximize click potential.",
  },
  {
    q: "Can you match my existing channel style?",
    a: "Absolutely. Whether your channel already has a recognizable style or you’re looking to evolve it, we create thumbnails that stay consistent with your brand while improving clarity, storytelling, and click potential.",
  },
  {
    q: "Do you use AI in your workflow?",
    a: "**Yes.** AI may be used as part of our production workflow for specific visual tasks when it helps achieve a better result. However, every project is driven by human research, creative strategy, concept development, design decisions, and final quality control. **All final thumbnail designs are completed and refined professionally in Adobe Photoshop.**",
  },
  {
    q: "How does payment work?",
    a: "Payment terms depend on the project and collaboration type. For most first-time projects, we work with an upfront payment before production begins. Larger or ongoing collaborations can be structured with milestone, weekly, or monthly payment arrangements.",
  },
  {
    q: "Why don’t you start designing right away?",
    a: "Every strong thumbnail starts with a strong direction. When concept development is included, we first review the video, analyze the context, and develop the strongest creative direction before moving into the final design. This ensures every thumbnail is built on strategy, not guesswork.",
  },
  {
    q: "What happens if I change the concept after work has started?",
    a: "Small refinements are part of the revision process. However, major changes such as switching the subject image or requesting a completely new concept require significant additional work and are treated as a separate revision or a new project, depending on the scope.",
  },
];

export const NAV = [
  { label: "Work", target: "#featured" },
  { label: "Process", target: "#process" },
  { label: "Services", target: "#services" },
  { label: "FAQ", target: "#faq" },
  { label: "Contact", target: "#contact" },
];
